import { render, staticRenderFns } from "./CampaignStatusComponent.vue?vue&type=template&id=287bca02&"
import script from "./CampaignStatusComponent.vue?vue&type=script&lang=js&"
export * from "./CampaignStatusComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports